import { Component, OnInit, Input } from '@angular/core';

import { HTTPService, DataService, HelperService } from 'app/services';
import { config } from 'app/constants';

@Component({
  selector: 'app-upcoming-appointment',
  templateUrl: './upcoming-appointment.component.html',
  styleUrls: ['./upcoming-appointment.component.scss'],
})
export class UpcomingAppointmentComponent implements OnInit {
  @Input('user')
  set user(data: any) {
    if (data) {
      this._user = data;
    }
  }
  @Input('appointments')
  set appointments(data: any) {
    if (data) {
      this.serverTime = data.current;
      this.filterAppts(data.appointments);
    }
  }
  @Input() vehicles: any[] = [];
  @Input() isLoadingAppointment: boolean = false;
  @Input() tab: string = '';
  @Input() isMarketingEnabled: boolean = false;
  @Input() exsistingEstimate: any = {};

  serverTime: any = '';
  estimate: any = {
    title: '',
    authorized: false,
    estimateBy: '',
    start: new Date(),
    end: null,
    orderStatus: config.estimate.defaultOrderStatus,
    workFlowStatus: null,
    notes: '',
    customerNotes: '',
    shopNotes: '',
    techs: [],
    customer: {},
    tags: [],
    appointments: [],
    services: [],
    inspections: [],
    isPickupScheduled: false,
    pickupDate: null,
  };
  isAppt: boolean = false;
  userAppointments: any;
  _user;
  pastAppts: any[] = [];
  presentAppt: any[] = [];
  isEstimateCreating: boolean = false;

  constructor(private httpService: HTTPService, private dataService: DataService, public helperService: HelperService) { }

  ngOnInit() { }

  openScheduleAppointmentModal() {
    this.dataService.sendData(
      this.dataService.typeDialog('add-appointment', 'upcoming-appointment', null, null, {
        _id: this._user._id,
        fullName: this._user.fullName,
        preferredLanguage: this._user.preferredLanguage,
      })
    );
  }

  createEstimate() {
    if (this.isEstimateCreating) {
      return;
    }

    this.isEstimateCreating = true;
    this.estimate.title = this._user.fullName;
    this.estimate.customer = {
      customerId: this._user._id,
      fullName: this._user.fullName,
      displayName: this._user.fullNameQBO,
      email: this._user.email,
      companyName: this._user.companyName,
      isFleetCustomer: this._user.isFleetCustomer,
      phone: this._user.phone,
      phone2: this._user.phone2,
      tags: this._user.tags,
      notes: this._user.notes,
    };

    // if (this.vehicles && this.vehicles.length) {
    //   const [vehicle] = this.vehicles;
    //   this.estimate.vehicle = {
    //     vehicleId: vehicle._id,
    //     name: vehicle.name,
    //   };
    // }

    /** Creating and open estimate in new tab */
    this.httpService
      .createEstimates({ ...this.estimate, activity: [], browserSessionId: Date.now() })
      .then(
        (order) => {
          const queryParams: any = {
            browserSessionToken: order.restriction.token || '',
            checkPreferredLocation: order.checkPreferredLocation || false,
          };
          const url = this.helperService.constructQueryParams(`/estimate/${order._id}`, queryParams);
          this.helperService.openPageInNewExistingTab(url, order._id);

          if (this.dataService.isGainSightPXEnabled) {
            const estimateCreated: any = {
              roCreationSource: this.tab ? `Customer side-panel ${this.tab}` : 'Customer side-panel',
              roNumber: order.code || '',
            };

            (<any>window).aptrinsic('track', 'RO Created', estimateCreated);
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isEstimateCreating = false;
      });
  }

  openCreditMemoModal() {
    const estimate = {
      ...this.exsistingEstimate,
      customer: {
        customerId: this._user._id,
        fullName: this._user.fullName,
        displayName: this._user.fullNameQBO,
        isFleetCustomer: this._user.isFleetCustomer,
      },
    };
    this.dataService.sendData(this.dataService.typeDialog('add-credit-payment', 'payment-list', null, null, { estimate }));
  }

  filterAppts(appointments: any[]) {
    const currentDateTime = this.serverTime;
    this.pastAppts = [];
    this.presentAppt = [];

    for (let i = 0; i < appointments.length; i++) {
      const appointment = appointments[i];

      if (new Date(appointment.startDateTime).getTime() < currentDateTime) {
        this.pastAppts.push(appointment);
      } else {
        this.presentAppt.push(appointment);
      }
    }
  }
}
